import styled from 'styled-components';
import { FilterBoxStyled } from '../FilterBoxStyled';

export const FilterBoxStyledAP = styled(FilterBoxStyled)``;
